// This file was generated by the build-public-api.ts script
export * from './components/dashboard/dashboard.component';
export * from './components/dashboard-widget/dashboard-widget.component';
export * from './dashboard.module';
export * from './dashboard.routes';
export * from './default-widgets';
export * from './widgets/latest-orders-widget/latest-orders-widget.component';
export * from './widgets/order-summary-widget/order-summary-widget.component';
export * from './widgets/test-widget/test-widget.component';
export * from './widgets/welcome-widget/welcome-widget.component';
